/* Live Visitor Counter (simulated) - Aitak theme */
(function () {
  var countEl = document.getElementById('lvc-count');
  if (!countEl) return;

  var bar = document.getElementById('lvc-bar');
  var MIN = parseInt(bar && bar.dataset.min, 10) || 18;
  var MAX = parseInt(bar && bar.dataset.max, 10) || 35;
  if (MAX <= MIN + 2) MAX = MIN + 3;
  var AVATAR_POOL = 70; // pravatar.cc supports img=1..70

  // Track which pravatar IDs are currently displayed (slots 0-4)
  var slotImgs = [1, 5, 12, 23, 34];

  function randInt(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }

  // Pick a new pravatar ID not already in slotImgs
  function pickFresh() {
    var n;
    do { n = randInt(1, AVATAR_POOL); } while (slotImgs.indexOf(n) !== -1);
    return n;
  }

  // Seed starting count biased toward middle of range
  function seedCount() {
    var mid  = Math.round((MIN + MAX) / 2);
    var seed = mid + Math.floor(Math.random() * 7) - 3;
    return Math.min(MAX, Math.max(MIN, seed));
  }

  var current = seedCount();
  countEl.textContent = current;

  // Flip animation when count changes
  function setCount(next) {
    if (next === current) return;
    current = next;
    countEl.classList.add('lvc-flip');
    setTimeout(function () {
      countEl.textContent = current;
      countEl.classList.remove('lvc-flip');
    }, 180);
  }

  // Random walk ±1–3 steps, nudged toward centre near edges
  function nextCount() {
    var step = Math.floor(Math.random() * 3) + 1;
    var dir  = Math.random() < 0.5 ? 1 : -1;
    if (current <= MIN + 2) dir = 1;
    if (current >= MAX - 2) dir = -1;
    return Math.min(MAX, Math.max(MIN, current + dir * step));
  }

  // Fade out 1 or 2 random avatar slots and swap in new faces
  function rotateAvatars() {
    var numToSwap = Math.random() < 0.45 ? 2 : 1;
    var slots = [];
    while (slots.length < numToSwap) {
      var idx = randInt(0, 4);
      if (slots.indexOf(idx) === -1) slots.push(idx);
    }
    slots.forEach(function (slotIdx) {
      var img = document.getElementById('lvc-av-' + slotIdx);
      if (!img) return;
      var newId = pickFresh();
      slotImgs[slotIdx] = newId;
      // Fade out
      img.style.transition = 'opacity 0.35s ease';
      img.style.opacity = '0';
      setTimeout(function () {
        var newSrc = 'https://i.pravatar.cc/60?img=' + newId;
        img.src = newSrc;
        // Fade in once loaded (or after short delay as fallback)
        var done = false;
        function fadeIn() { if (done) return; done = true; img.style.opacity = '1'; }
        img.onload  = fadeIn;
        img.onerror = fadeIn;
        setTimeout(fadeIn, 400);
      }, 370);
    });
  }

  // Schedule tick: update count + rotate avatars
  function schedule() {
    var delay = 4000 + Math.floor(Math.random() * 5000); // 4–9 s
    setTimeout(function () {
      setCount(nextCount());
      rotateAvatars();
      schedule();
    }, delay);
  }

  // First tick after a short stagger (0.8–2 s) to feel live immediately
  setTimeout(function () {
    setCount(nextCount());
    rotateAvatars();
    schedule();
  }, 800 + Math.floor(Math.random() * 1200));
})();
